import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";
import { Globe, CalendarCheck, Users, ShieldCheck, Briefcase, Cpu, Calculator, Headphones, Receipt } from "lucide-react";

const icons = [Globe, CalendarCheck, Users, ShieldCheck, Briefcase, Cpu, Calculator, Headphones, Receipt];

export default function Services() {
  const { t } = useLanguage();
  const items = t("services.items");

  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 lg:py-48">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 md:mb-20"
        >
          <span className="font-mono text-xs tracking-[0.25em] text-[#00F0FF] mb-4 block">
            {t("services.overline")}
          </span>
          <h2 className="font-outfit font-bold text-4xl md:text-5xl leading-tight tracking-tighter text-white mb-4">
            {t("services.title")}
          </h2>
          <p className="text-lg text-neutral-400 font-manrope max-w-2xl">
            {t("services.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {Array.isArray(items) && items.map((item, i) => {
            const Icon = icons[i] || Cpu;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className="bg-[#050505] p-8 md:p-10 group hover:bg-[#0a0a0a] transition-colors duration-300"
                data-testid={`service-card-${i}`}
              >
                <Icon className="w-6 h-6 text-[#00F0FF] mb-6 group-hover:drop-shadow-[0_0_8px_rgba(0,240,255,0.5)] transition-all duration-300" />
                <h3 className="font-outfit font-medium text-xl text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-neutral-500 font-manrope leading-relaxed">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
